module.exports = __webpack_public_path__ + "assets/img/title-3b911184.png";